import {Control, Controller} from 'react-hook-form';
import Input from './input';

interface IProps {
  control: Control<any, any>;
  name: string;
  validation?: Record<string, any>;
  label: string | JSX.Element;
  className?: string;
  placeholder?: string;
  type?: string;
  multiline?: boolean;
  error?: string;
  disabled?: boolean;
}

const InputController: React.FC<IProps> = ({validation, control, name, ...inputProps}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={validation}
      render={({field: {name, onChange, value, ref}}) => (
        <Input name={name} onChange={onChange} value={value} {...inputProps} />
      )}
    />
  );
};

export default InputController;
